import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../models/api-response.model';
import { map } from 'rxjs';

export interface Autorizacion {
  id?: string;
  tenant_id?: string;
  sucursal_id: string;
  tipo: string;
  estado: 'PENDIENTE' | 'APROBADA' | 'RECHAZADA';
  solicitante?: { id: string; nombre: string };
  aprobador?: { id: string; nombre: string };
  metadata: any;
  createdAt?: string;
  updatedAt?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AutorizacionesService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/autorizaciones`;

  create(data: Partial<Autorizacion>): Observable<Autorizacion> {
    return this.http.post<ApiResponse<Autorizacion>>(this.apiUrl, data).pipe(map(res => res.data));
  }

  getAll(estado?: string, sucursal_id?: string): Observable<{items: Autorizacion[]}> {
    let params: any = {};
    if (estado) params.estado = estado;
    if (sucursal_id) params.sucursal_id = sucursal_id;
    return this.http.get<ApiResponse<{items: Autorizacion[]}>>(this.apiUrl, { params }).pipe(map(res => res.data));
  }

  update(id: string, estado: 'APROBADA' | 'RECHAZADA'): Observable<any> {
    return this.http.put<ApiResponse<any>>(`${this.apiUrl}/${id}`, { estado }).pipe(map(res => res.data));
  }
}
